module.exports = __webpack_public_path__ + "img/Reg-7-Recommend.050f773d.svg";